import { render } from "./listall.vue?vue&type=template&id=2ab99338&scoped=true"
import script from "./listall.vue?vue&type=script&lang=js"
export * from "./listall.vue?vue&type=script&lang=js"

import "./listall.vue?vue&type=style&index=0&id=2ab99338&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab99338"]])

export default __exports__